module.exports = __webpack_public_path__ + "static/orc-7fb1a38fe874f77bedea3a5f34a85106.jpeg";